import*as o from"react";const e=(e,r)=>o.useMemo((()=>e&&r?`${e}-${r}`:void 0),[e,r]);export{e as useTestId};
